export default "__VITE_PUBLIC_ASSET__bdc8f072__"